<template>
    <transition appear name="fade-transition">
        <template v-if="$vuetify.breakpoint.mobile">
            <app-menu-button />
        </template>
        <template v-else>
            <div class="app-menu">
                <app-nav-menu :items="items" horizontal />
            </div>
        </template>
    </transition>
</template>

<script>
import getMenu from '@/router/lib/getMenu';

export default {
    name: 'AppMenu',
    components: {
        AppMenuButton: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppMenuButton'
            ),
        AppNavMenu: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppNavMenu'
            )
    },
    data: () => ({
        items: []
    }),
    beforeDestroy() {
        this.items = [];
    },
    methods: {
        async setup() {
            this.items = await getMenu('primary');
        }
    }
};
</script>
<style lang="scss">
.app-menu {
    flex: 1 1 auto;
    height: 100%;
    border-left: 1px solid rgba(0, 0, 0, 0.07);
}
</style>
